import {
  isNeedsAttentionPaymentInstructionStatus,
  PaymentInstructionStatus,
  PaymentMethod
} from '@sollapay/enums';

import type {PaymentInstructionDTO} from '@sollapay/types';

/** A payin under the instruction is in PATC or PENDING_ADDITIONAL_AUTHORIZATION — locked while the bank awaits more signers/approval. */
function isAwaitingAdditionalAuthorization(instruction: PaymentInstructionDTO): boolean {
  return Boolean(instruction.awaitingAdditionalAuthorizationReason);
}

export function canResendInstruction(instruction: PaymentInstructionDTO): boolean {
  if (isAwaitingAdditionalAuthorization(instruction)) return false;
  return (
    instruction.status === PaymentInstructionStatus.AWAITING_FUNDS &&
    instruction.initiationMethod === PaymentMethod.PIS
  );
}

export function canCancelInstruction(instruction: PaymentInstructionDTO): boolean {
  if (isAwaitingAdditionalAuthorization(instruction)) return false;
  return [
    PaymentInstructionStatus.PENDING_EXECUTION,
    PaymentInstructionStatus.EXECUTING,
    PaymentInstructionStatus.REISSUING,
    PaymentInstructionStatus.AWAITING_FUNDS
  ].includes(instruction.status);
}

export function canMarkHandledInstruction(instruction: PaymentInstructionDTO): boolean {
  return isNeedsAttentionPaymentInstructionStatus(instruction.status) && !instruction.handledAt;
}
